import { useEffect } from 'react';
import { AUTH_KEY } from '../consts/auth';
import { getNewRefreshTime } from '../lib/token';

export const useFixRefreshTime = () => {
  useEffect(() => {
    const refreshTime = localStorage.getItem(`${AUTH_KEY}_refresh_time`);

    if (!refreshTime) {
      return;
    }

    // Try parsing as date first
    const parsedDate = new Date(refreshTime);
    const currentYear = new Date().getFullYear();
    const isInvalidDate = parsedDate.toString() === 'Invalid Date';
    const isUnreasonableDate = Math.abs(parsedDate.getFullYear() - currentYear) > 1;

    if (!isInvalidDate && !isUnreasonableDate) {
      // Already a valid reasonable date string, no conversion needed
      return;
    }

    const minutes = parseInt(refreshTime);
    const newRefreshTime = getNewRefreshTime(minutes);
    localStorage.setItem(`${AUTH_KEY}_refresh_time`, newRefreshTime);
  }, []);
}; 